import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { SidebarNavItem } from '@bci-web-core/core';
import { CommonService } from 'src/app/services';
import { Constants } from '../utils/constants';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  public sidebarLinks: SidebarNavItem[] = [];

  constructor(
    private router: Router,
    private commonService: CommonService,
    private alertService: AlertService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let loggedInUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!this.commonService.isNullOrUndefined(loggedInUser)) {
      if (this.checkPermission(state.url, loggedInUser)) {
        return true;
      } else {
        this.alertService.showInfo(
          'You do not have permission to view this page!'
        );
        this.router.navigate(['/site-master']);
      }
    } else {
      this.router.navigate(['/login'], {
        queryParams: { returnUrl: state.url }
      });
    }
    return false;
  }
  // isTokenExpired(token: string): boolean {
  //   if (!token) return true;

  //   try {
  //     const decoded: any = jwtDecode(token);
  //     const currentTime = Math.floor(new Date().getTime() / 1000);
  //     const eightHoursInSeconds = 170 * 60 * 60;
      
  //     // Check if the current time exceeds the token's expiry time by 8 hours
  //     return currentTime > (decoded.exp + eightHoursInSeconds);
  //   } catch (error) {
  //     console.error('Error decoding token', error);
  //     return true;
  //   }
  // }

  private checkPermission(url: string, user: any) {

    // if (localStorage.getItem('access_token')) {return(
    //   localStorage.getItem('access_token') && !this.isTokenExpired(localStorage.getItem('access_token')))
    // }
    // else{
    //   return false;
    // }

    let isAllowed = false;
    let code = '';

    for (
      let i = 0;
      i < Constants.defaultMenus.English.length && !isAllowed;
      i++
    ) {
      if (Constants.defaultMenus.English[i].items) {
        for (
          let j = 0;
          j < Constants.defaultMenus.English[i].items.length;
          j++
        ) {
          if (url.includes(Constants.defaultMenus.English[i].items[j].url)) {
            code = Constants.defaultMenus.English[i].items[j].code;
            break;
          }
        }
      } else if (url.includes(Constants.defaultMenus.English[i].url)) {
        code = Constants.defaultMenus.English[i].code;
        break;
      }
    }

    for (let k = 0; k < user.menuItems.length; k++) {
      if (
        user.menuItems[k].code === code ||
        url.includes('/site') ||
        url.includes('/utility-consumptionCharts') ||
        url.includes('/setup-project?siteId')
      ) {
        isAllowed = true;
        break;
      } else {
        isAllowed = false;
      }
    }

    return isAllowed;
  }
}
